import {gsap} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

interface IBitmapTextStyleOptions {
    fontName: string;
    fontSize: number;
    align?: string;
    tint?: number;
}

export class BasicBitmapCountUp extends PIXI.Container {
    public currentCountValue: number;     //Used by greensock. Don't change
    private readonly _amountText: PIXI.BitmapText;
    private _anchor: PIXI.Point;
    private readonly _maxWidth: number | undefined;
    private _activeAnimation?: gsap.core.Timeline;
    private _prevValue: number;
    private _pareCalculatedScale: boolean;

    constructor(style: IBitmapTextStyleOptions, maxWidth?: number, anchor?: PIXI.Point) {
        super();
        this._maxWidth = maxWidth;
        this._anchor = anchor ? anchor : new PIXI.Point(0.5, 0.5);
        this._amountText = new PIXI.BitmapText("0000000", style);
        this.addChild(this._amountText);
    }

    public stopAt(amount: number): void {
        if (this._activeAnimation != undefined) {
            this._activeAnimation.pause();
            this._activeAnimation.kill();
        }
        delete this._activeAnimation;
        this.currentCountValue = amount;
        this._prevValue = amount;
        this.setAmount(amount);
    }

    public getCountAnimation(from: number, to: number, duration: number, ease: string | gsap.EaseFunction = "none"): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({onUpdate: () => this.updateText()});
        tl.add(() => {
            this.stopAt(from);
            this._activeAnimation = tl;
        });

        if (!this._pareCalculatedScale) {
            tl.add(() => this.setScaleToFitMaxWidth(from, to));
        }

        tl.add(() => this.updateTextLayout());
        tl.to(this, {duration: duration, currentCountValue: to, ease: ease});
        tl.add(() => {
            this.stopAt(to);
        });
        return tl;
    }

    private updateText(): void {
        if (this.currentCountValue - this._prevValue > 0.01) {
            this.setAmount(this.currentCountValue);
            this._prevValue = this.currentCountValue;
        }
    }

    private setAmount(value: number): void {
        const newString = SlotGame.apiPlugin.currency.formatValue(value);
        if (newString.length != this._amountText.text.length) {
            this._amountText.text = newString;
            this.updateTextLayout();
        } else {
            this._amountText.text = newString;
        }
    }

    private updateTextLayout(): void {
        this._amountText.position.set(-this._amountText.width * this._anchor.x, -this._amountText.height * this._anchor.y);
    }

    private setScaleToFitMaxWidth(from: number, to: number): void {
        let textScale = 1;
        if (this._maxWidth != undefined) {
            this._amountText.scale.set(1);
            this.setAmount(to);
            textScale = Math.min(this._maxWidth / this._amountText.width, 1);
            this.setAmount(from);
        }
        this._amountText.scale.set(textScale);
    }
}